/**
 * Composant pour gérer le popup de mise à jour du ranking
 */
class RankingPopup {
    constructor() {
        this.popupShown = false;
        this.lastPromptDate = localStorage.getItem('lastRankingPromptDate');
        this.userId = document.querySelector('meta[name="user-id"]')?.content;
        this.hasRanking = document.querySelector('meta[name="has-ranking"]')?.content === 'true';
        this.accountAgeDays = parseInt(document.querySelector('meta[name="account-age-days"]')?.content) || 0;
        // Calculé côté PHP : true si le compte a 7 jours ou moins
        this.accountRecent = document.querySelector('meta[name="account-recent"]')?.content === 'true';
    }

    /**
     * Initialise le popup
     */
    init() {
        // Si l'utilisateur n'est pas connecté, on ne fait rien
        if (!this.userId) {
            return;
        }

        // Vérifier si on doit afficher le popup
        if (this.shouldShowPopup()) {
            this.createPopup();
        }
    }

    /**
     * Détermine si le popup doit être affiché
     * @returns {boolean}
     */
    shouldShowPopup() {
        if (this.hasRanking) {
            return false;
        }

        // Ne pas afficher si le compte a plus de 7 jours (règle calculée côté PHP)
        if (!this.accountRecent) {
            return false;
        }

        if (this.lastPromptDate) {
            const lastDate = new Date(this.lastPromptDate);
            const now = new Date();
            const diffDays = Math.floor((now - lastDate) / (1000 * 60 * 60 * 24));

            // Plus de 7 jours depuis le premier affichage → ne plus jamais afficher
            if (diffDays >= 7) {
                return false;
            }

            // Sinon, ne pas réafficher le même jour
            return false;
        }

        return true;
    }

    /**
     * Crée et affiche le popup
     */
    createPopup() {
        // Créer l'élément du popup
        const popupElement = document.createElement('div');
        popupElement.className = 'ranking-popup-overlay';
        popupElement.innerHTML = `
            <div class="ranking-popup">
                <div class="ranking-popup-header">
                    <h3>Mettez à jour votre ranking eFootball</h3>
                    <button type="button" class="close-popup"><span class="material-icons">close</span></button>
                </div>
                <div class="ranking-popup-body">
                    <p>Pour améliorer votre expérience sur Master League, nous avons besoin de connaître votre niveau sur eFootball.</p>
                    <p>Cela nous permettra de :</p>
                    <ul>
                        <li>Calculer la réputation de votre club</li>
                        <li>Améliorer les mécaniques de recrutement</li>
                        <li>Faciliter les négociations avec les joueurs</li>
                    </ul>
                    <p>Veuillez télécharger une capture d'écran de votre profil eFootball montrant votre nom d'utilisateur, votre meilleure division et votre ranking actuel.</p>
                </div>
                <div class="ranking-popup-footer">
                    <button type="button" class="btn-remind remind-later">Me le rappeler plus tard</button>
                    <a href="/profile/ranking/upload" class="btn-update">Mettre à jour maintenant</a>
                </div>
            </div>
        `;

        // Ajouter le popup au body
        document.body.appendChild(popupElement);
        this.popupShown = true;

        // Ajouter les styles CSS
        this.addStyles();

        // Ajouter les événements
        this.addEvents(popupElement);

        // Enregistrer la date d'affichage
        localStorage.setItem('lastRankingPromptDate', new Date().toISOString());
    }

    /**
     * Ajoute les styles CSS pour le popup
     */
    addStyles() {
        if (!document.getElementById('ranking-popup-styles')) {
            const styleElement = document.createElement('style');
            styleElement.id = 'ranking-popup-styles';
            styleElement.textContent = `
                .ranking-popup-overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background-color: rgba(0, 0, 0, 0.7);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    z-index: 9999;
                }
                .ranking-popup-overlay .ranking-popup {
                    background-color: #1a1f3a;
                    border: 1px solid rgba(255, 255, 255, 0.1);
                    border-radius: 12px;
                    width: 90%;
                    max-width: 500px;
                    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
                    overflow: hidden;
                }
                .ranking-popup-overlay .ranking-popup-header {
                    padding: 16px 20px;
                    background-color: rgba(255, 255, 255, 0.05);
                    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }
                .ranking-popup-overlay .ranking-popup-header h3 {
                    margin: 0;
                    font-size: 1.15rem;
                    color: #FFD700;
                    font-weight: 700;
                }
                .ranking-popup-overlay .close-popup {
                    background: none;
                    border: none;
                    color: rgba(255, 255, 255, 0.5);
                    cursor: pointer;
                    padding: 4px;
                    line-height: 1;
                    transition: color 0.2s;
                    display: flex;
                }
                .ranking-popup-overlay .close-popup:hover {
                    color: white;
                }
                .ranking-popup-overlay .ranking-popup-body {
                    padding: 20px;
                    color: rgba(255, 255, 255, 0.8);
                    line-height: 1.6;
                }
                .ranking-popup-overlay .ranking-popup-body ul {
                    margin: 8px 0;
                    padding-left: 20px;
                }
                .ranking-popup-overlay .ranking-popup-body li {
                    margin-bottom: 4px;
                }
                .ranking-popup-overlay .ranking-popup-footer {
                    padding: 16px 20px;
                    background-color: rgba(255, 255, 255, 0.03);
                    border-top: 1px solid rgba(255, 255, 255, 0.1);
                    display: flex;
                    justify-content: flex-end;
                    gap: 10px;
                }
                .ranking-popup-overlay .btn-update {
                    background-color: #FFD700;
                    color: #000;
                    font-weight: 700;
                    padding: 8px 20px;
                    border-radius: 6px;
                    text-decoration: none;
                    font-size: 0.875rem;
                    transition: background-color 0.2s;
                }
                .ranking-popup-overlay .btn-update:hover {
                    background-color: #e6c200;
                }
                .ranking-popup-overlay .btn-remind {
                    background-color: rgba(255, 255, 255, 0.1);
                    color: rgba(255, 255, 255, 0.7);
                    font-weight: 600;
                    padding: 8px 20px;
                    border-radius: 6px;
                    border: none;
                    cursor: pointer;
                    font-size: 0.875rem;
                    transition: background-color 0.2s, color 0.2s;
                }
                .ranking-popup-overlay .btn-remind:hover {
                    background-color: rgba(255, 255, 255, 0.15);
                    color: white;
                }
                .ranking-popup-btn {
                    display: inline-flex;
                    align-items: center;
                    gap: 6px;
                    padding: 8px 16px;
                    border-radius: 6px;
                    border: none;
                    cursor: pointer;
                    font-size: 0.875rem;
                    font-weight: 600;
                    text-decoration: none;
                    transition: background-color 0.2s, color 0.2s;
                }
                .ranking-popup-btn .material-icons { font-size: 18px; }
                .ranking-popup-btn--go {
                    background-color: #FFD700;
                    color: #000;
                }
                .ranking-popup-btn--go:hover { background-color: #e6c200; color: #000; }
                .ranking-popup-btn--cancel {
                    background-color: rgba(239, 68, 68, 0.15);
                    color: #f87171;
                    border: 1px solid rgba(239, 68, 68, 0.3);
                }
                .ranking-popup-btn--cancel:hover { background-color: rgba(239, 68, 68, 0.25); }
                .ranking-popup-btn--close {
                    background-color: rgba(255, 255, 255, 0.1);
                    color: rgba(255, 255, 255, 0.7);
                }
                .ranking-popup-btn--close:hover { background-color: rgba(255, 255, 255, 0.15); color: white; }
            `;
            document.head.appendChild(styleElement);
        }
    }

    /**
     * Ajoute les événements au popup
     * @param {HTMLElement} popupElement 
     */
    addEvents(popupElement) {
        // Fermer le popup
        const closeButton = popupElement.querySelector('.close-popup');
        closeButton.addEventListener('click', () => {
            this.closePopup(popupElement);
        });

        // Rappeler plus tard
        const remindLaterButton = popupElement.querySelector('.remind-later');
        remindLaterButton.addEventListener('click', () => {
            this.closePopup(popupElement);
        });
    }

    /**
     * Ferme le popup
     * @param {HTMLElement} popupElement 
     */
    closePopup(popupElement) {
        document.body.removeChild(popupElement);
        this.popupShown = false;
    }
}

// Initialiser le popup lorsque le DOM est chargé
document.addEventListener('DOMContentLoaded', () => {
    const rankingPopup = new RankingPopup();
    rankingPopup.init();
});
